import { useApolloClient } from '@apollo/client/react';
import { Button } from '@staff-app/ui';
import { useAuthStore } from '@/stores/auth-store';
import { fullLogout } from '@/lib/logout';

/**
 * Shown when Firebase has authenticated a user but the backend `staffMe` query
 * returned null. Since @optisigns.com users now self-provision as `member` on
 * first sign-in, this is reached when the account is disabled by a root admin
 * (or on a transient backend error). Non-@optisigns.com identities are blocked
 * earlier at the domain gate.
 */
export function PendingApprovalPage() {
  const client = useApolloClient();
  const firebaseUser = useAuthStore((s) => s.firebaseUser);

  const handleSignOut = async () => {
    await fullLogout(client);
    // No explicit navigate — logout clears token, ProtectedRoute will bounce
    // to /staff/login on the next render.
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-muted px-4"
      data-testid="pending-approval-page"
    >
      <div className="w-full max-w-md rounded-lg border bg-card p-8 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-foreground">{'Account unavailable'}</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          {'Your account may be disabled. Contact a root admin (Henry, Paul, or Frank).'}
        </p>
        {firebaseUser?.email ? (
          <p className="mt-4 rounded-md bg-muted px-3 py-2 text-sm font-medium text-foreground">
            {firebaseUser.email}
          </p>
        ) : null}
        <Button
          variant="outline"
          className="mt-6 w-full"
          onClick={handleSignOut}
          data-testid="pending-approval-sign-out"
        >
          {'Sign out'}
        </Button>
      </div>
    </div>
  );
}
